const initialState = {
  token: null,
  user: null,
  initialSocketData: null,
  appointment_obj: null,
  is_video_call_start: false,
  is_actual_call_started: false,
  isCallEndFromPatient: false,
  isCallAgain: false,
  offline_call_status: false,
  callCounterData: null,
  isCallAgainEMDR: false,
  newAppointmentObj: null,
  isCallAgainGuest: false,
  appointment_tab: null,
  verifiedPatientDob: null,
  emdr_bg_image: null,
  is_signin: true,
  plan_details: null,
  is_doctor_stream_created: null,
  // dynamicInputs: null,
};
const actionTypes = {
  ON_SET_APPOINTMENT_TAB: "ON_SET_APPOINTMENT_TAB",
  CLEAR_LOCAL_STATE: "CLEAR_LOCAL_STATE",
  ON_SET_PATIENT_APPOINTMENT: "ON_SET_PATIENT_APPOINTMENT",
  SET_INTIAL_SOCKET_DATA: "SET_INTIAL_SOCKET_DATA",
  IS_VIDEO_CALL_STARTED: "IS_VIDEO_CALL_STARTED",
  IS_CALL_END_FROM_PATIENT: "IS_CALL_END_FROM_PATIENT",
  ON_CALL_AGAIN: "ON_CALL_AGAIN",
  SET_OFFLINE_CALL_STATUS: "SET_OFFLINE_CALL_STATUS",
  ACTUAL_CALL_STARTED: "ACTUAL_CALL_STARTED",
  SET_CALL_COUNTER_DATA: "SET_CALL_COUNTER_DATA",
  ON_CALL_AGAIN_EMDR: "ON_CALL_AGAIN_EMDR",
  SET_NEW_APPOINTMENT: "SET_NEW_APPOINTMENT",
  ON_CALL_AGAIN_GUEST: "ON_CALL_AGAIN_GUEST",
  ON_SET_PATIENT_DOB: "ON_SET_PATIENT_DOB",
  ON_SET_EMDR_BG_IMAGE: "ON_SET_EMDR_BG_IMAGE",
  IS_SIGNIN: "IS_SIGNIN",
  SET_PLAN_DETAILS: "SET_PLAN_DETAILS",
  SET_DOCTOR_STREAM_CREATED: "SET_DOCTOR_STREAM_CREATED",
};

const sessionTypes = {
  LOGIN_SUCCESS: "session/LOGIN_SUCCESS",
  LOG_OUT: "session/LOG_OUT",
};
export const localStore = (state = initialState, action) => {
  switch (action.type) {
    case sessionTypes.LOGIN_SUCCESS: {
      const { token, user, reset_pass_token } = action.payload;
      return { ...state, user, token, reset_pass_token };
    }
    case sessionTypes.LOG_OUT:
      return initialState;
    case actionTypes.SET_DOCTOR_STREAM_CREATED:
      return { ...state, is_doctor_stream_created: action.payload };
    case actionTypes.ON_SET_PATIENT_APPOINTMENT:
      return { ...state, appointment_obj: action.payload };
    case actionTypes.ON_SET_APPOINTMENT_TAB:
      return { ...state, appointment_tab: action.payload };
    case actionTypes.SET_NEW_APPOINTMENT:
      return { ...state, newAppointmentObj: action.payload };
    case actionTypes.SET_INTIAL_SOCKET_DATA:
      return { ...state, initialSocketData: action.payload };
    case actionTypes.IS_VIDEO_CALL_STARTED:
      return { ...state, is_video_call_start: action.payload };
    case actionTypes.IS_CALL_END_FROM_PATIENT:
      return { ...state, isCallEndFromPatient: action.payload };
    case actionTypes.ON_CALL_AGAIN:
      return { ...state, isCallAgain: action.payload };
    case actionTypes.SET_OFFLINE_CALL_STATUS:
      return { ...state, offline_call_status: action.payload };
    case actionTypes.ACTUAL_CALL_STARTED:
      return { ...state, is_actual_call_started: action.payload };
    case actionTypes.SET_CALL_COUNTER_DATA:
      return { ...state, callCounterData: action.payload };
    case actionTypes.ON_CALL_AGAIN_EMDR:
      return { ...state, isCallAgainEMDR: action.payload };
    case actionTypes.ON_CALL_AGAIN_GUEST:
      return { ...state, isCallAgainGuest: action.payload };
    case actionTypes.ON_SET_PATIENT_DOB:
      return { ...state, verifiedPatientDob: action.payload };
    case actionTypes.ON_SET_EMDR_BG_IMAGE:
      return { ...state, emdr_bg_image: action.payload };
    case actionTypes.SET_PLAN_DETAILS:
      return { ...state, plan_details: action.payload };
    case actionTypes.IS_SIGNIN:
      return { ...state, is_signin: action.payload };
    case actionTypes.CLEAR_LOCAL_STATE:
      return { ...initialState };

    default:
      return state;
  }
};
